<section fxFlex.xs="20%">
  <div class="buttons">
    <button (click)="ChangeMode()" class="btn btn-primary mr-1 mb-1">
      {{buttonName}}
    </button>
  </div>
</section>
